import { WEB_ASSETS } from '@tenfour/contracts'
import { useArrivalAnimation } from './useArrivalAnimation'
import { HexRipple } from './HexRipple'
import s from './visuals.module.css'

export function SignupLogo({ className }: { className?: string }) {
  return <img className={`${s.logo} ${className ?? ''}`.trim()} src={WEB_ASSETS.brand.favicon}
    alt="Ten Four" width="48" height="48" draggable={false} />
}

/** One arrival: a hex ripple, the center mark, then its move to the chat header. */
export function SignupIntro({ onComplete, className }: { onComplete: () => void; className?: string }) {
  const ref = useArrivalAnimation(onComplete)
  return (
    <div ref={ref} className={`${s.intro} ${className ?? ''}`.trim()} aria-hidden="true">
      <HexRipple className={s.introRipple} />
      <div className={s.introLogo} data-arrival-logo><SignupLogo /></div>
    </div>
  )
}
